import type { ProgramQuote } from '@makemydeal/dr-dash-types';
import { SelectActionColumnBody } from './SelectActionColumnBody';

export const createSelectActionColumn =
    (appliedProgramKey: string, pendingApplyKey = '') =>
    (_text: any, value: ProgramQuote & { key?: string }, index: number) => {
        return (
            <SelectActionColumnBody
                value={value}
                index={index}
                appliedProgramKey={appliedProgramKey}
                pendingApplyKey={pendingApplyKey}
            />
        );
    };
